import React from "react";
import { Box } from "@chakra-ui/react";

export const HauntedHouseBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Dark interior wall base */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 50%, #080808 100%)"
      />

      {/* Wallpaper texture pattern overlay */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        opacity="0.15"
        backgroundImage="repeating-linear-gradient(
          0deg,
          transparent,
          transparent 40px,
          rgba(60,40,40,0.3) 40px,
          rgba(60,40,40,0.3) 42px
        ),
        repeating-linear-gradient(
          90deg,
          transparent,
          transparent 40px,
          rgba(60,40,40,0.2) 40px,
          rgba(60,40,40,0.2) 42px
        )"
      />

      {/* Window and interior SVG */}
      <svg
        className="haunted-svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Moonlight gradient for windows */}
          <linearGradient id="moonlightGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#2a3a5a" stopOpacity="1" />
            <stop offset="40%" stopColor="#1a2a4a" stopOpacity="1" />
            <stop offset="100%" stopColor="#0a1525" stopOpacity="1" />
          </linearGradient>

          {/* Window frame gradient */}
          <linearGradient id="frameGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2a2020" stopOpacity="1" />
            <stop offset="50%" stopColor="#1a1515" stopOpacity="1" />
            <stop offset="100%" stopColor="#0d0a0a" stopOpacity="1" />
          </linearGradient>

          {/* Floor plank gradients */}
          <linearGradient id="plankGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#3d2a1a" stopOpacity="1" />
            <stop offset="50%" stopColor="#2a1c10" stopOpacity="1" />
            <stop offset="100%" stopColor="#1a1008" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="plankGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#4a3520" stopOpacity="1" />
            <stop offset="50%" stopColor="#352415" stopOpacity="1" />
            <stop offset="100%" stopColor="#20140a" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="plankGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#3a2818" stopOpacity="1" />
            <stop offset="50%" stopColor="#28180c" stopOpacity="1" />
            <stop offset="100%" stopColor="#180e06" stopOpacity="1" />
          </linearGradient>

          {/* Wood grain pattern */}
          <pattern id="woodGrain" patternUnits="userSpaceOnUse" width="200" height="20">
            <rect width="200" height="20" fill="transparent" />
            <path d="M0,5 Q50,3 100,6 Q150,9 200,5" stroke="rgba(0,0,0,0.15)" strokeWidth="1" fill="none" />
            <path d="M0,12 Q40,10 80,13 Q130,16 200,11" stroke="rgba(0,0,0,0.1)" strokeWidth="1" fill="none" />
            <path d="M0,18 Q60,16 120,19 Q170,17 200,18" stroke="rgba(0,0,0,0.08)" strokeWidth="1" fill="none" />
          </pattern>

          {/* Moon glow */}
          <radialGradient id="moonGlow" cx="50%" cy="30%" r="50%">
            <stop offset="0%" stopColor="#e8e8ff" stopOpacity="0.9" />
            <stop offset="30%" stopColor="#c0c0e0" stopOpacity="0.6" />
            <stop offset="100%" stopColor="transparent" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Left large window */}
        <g className="window-left">
          {/* Window opening - night sky */}
          <rect x="80" y="100" width="280" height="450" fill="url(#moonlightGrad)" />

          {/* Moon in left window */}
          <circle cx="180" cy="180" r="35" fill="url(#moonGlow)" className="moon" />
          <circle cx="180" cy="180" r="20" fill="#e8e8f0" />

          {/* Window frame */}
          <rect x="70" y="90" width="300" height="20" fill="url(#frameGrad)" />
          <rect x="70" y="540" width="300" height="25" fill="url(#frameGrad)" />
          <rect x="70" y="90" width="20" height="475" fill="url(#frameGrad)" />
          <rect x="360" y="90" width="20" height="475" fill="url(#frameGrad)" />

          {/* Window cross bars */}
          <rect x="80" y="300" width="280" height="12" fill="url(#frameGrad)" />
          <rect x="210" y="100" width="12" height="450" fill="url(#frameGrad)" />
        </g>

        {/* Right large window */}
        <g className="window-right">
          {/* Window opening - night sky */}
          <rect x="1080" y="100" width="280" height="450" fill="url(#moonlightGrad)" />

          {/* Stars in right window */}
          <circle cx="1150" cy="150" r="2" fill="#ffffff" opacity="0.8" className="star-1" />
          <circle cx="1250" cy="180" r="1.5" fill="#ffffff" opacity="0.6" className="star-2" />
          <circle cx="1200" cy="220" r="2" fill="#ffffff" opacity="0.7" className="star-3" />
          <circle cx="1300" cy="140" r="1" fill="#ffffff" opacity="0.5" className="star-4" />
          <circle cx="1120" cy="200" r="1.5" fill="#ffffff" opacity="0.6" className="star-5" />

          {/* Window frame */}
          <rect x="1070" y="90" width="300" height="20" fill="url(#frameGrad)" />
          <rect x="1070" y="540" width="300" height="25" fill="url(#frameGrad)" />
          <rect x="1070" y="90" width="20" height="475" fill="url(#frameGrad)" />
          <rect x="1360" y="90" width="20" height="475" fill="url(#frameGrad)" />

          {/* Window cross bars */}
          <rect x="1080" y="300" width="280" height="12" fill="url(#frameGrad)" />
          <rect x="1210" y="100" width="12" height="450" fill="url(#frameGrad)" />
        </g>

        {/* Wooden floor planks */}
        <g className="wooden-floor">
          {/* Row 1 - staggered planks */}
          <rect x="0" y="700" width="180" height="25" fill="url(#plankGrad1)" />
          <rect x="0" y="700" width="180" height="25" fill="url(#woodGrain)" />
          <rect x="182" y="700" width="220" height="25" fill="url(#plankGrad2)" />
          <rect x="182" y="700" width="220" height="25" fill="url(#woodGrain)" />
          <rect x="404" y="700" width="190" height="25" fill="url(#plankGrad3)" />
          <rect x="404" y="700" width="190" height="25" fill="url(#woodGrain)" />
          <rect x="596" y="700" width="210" height="25" fill="url(#plankGrad1)" />
          <rect x="596" y="700" width="210" height="25" fill="url(#woodGrain)" />
          <rect x="808" y="700" width="185" height="25" fill="url(#plankGrad2)" />
          <rect x="808" y="700" width="185" height="25" fill="url(#woodGrain)" />
          <rect x="995" y="700" width="225" height="25" fill="url(#plankGrad3)" />
          <rect x="995" y="700" width="225" height="25" fill="url(#woodGrain)" />
          <rect x="1222" y="700" width="218" height="25" fill="url(#plankGrad1)" />
          <rect x="1222" y="700" width="218" height="25" fill="url(#woodGrain)" />

          {/* Row 2 - offset */}
          <rect x="-60" y="727" width="200" height="25" fill="url(#plankGrad2)" />
          <rect x="-60" y="727" width="200" height="25" fill="url(#woodGrain)" />
          <rect x="142" y="727" width="195" height="25" fill="url(#plankGrad3)" />
          <rect x="142" y="727" width="195" height="25" fill="url(#woodGrain)" />
          <rect x="339" y="727" width="215" height="25" fill="url(#plankGrad1)" />
          <rect x="339" y="727" width="215" height="25" fill="url(#woodGrain)" />
          <rect x="556" y="727" width="188" height="25" fill="url(#plankGrad2)" />
          <rect x="556" y="727" width="188" height="25" fill="url(#woodGrain)" />
          <rect x="746" y="727" width="222" height="25" fill="url(#plankGrad3)" />
          <rect x="746" y="727" width="222" height="25" fill="url(#woodGrain)" />
          <rect x="970" y="727" width="198" height="25" fill="url(#plankGrad1)" />
          <rect x="970" y="727" width="198" height="25" fill="url(#woodGrain)" />
          <rect x="1170" y="727" width="210" height="25" fill="url(#plankGrad2)" />
          <rect x="1170" y="727" width="210" height="25" fill="url(#woodGrain)" />
          <rect x="1382" y="727" width="200" height="25" fill="url(#plankGrad3)" />
          <rect x="1382" y="727" width="200" height="25" fill="url(#woodGrain)" />

          {/* Row 3 */}
          <rect x="0" y="754" width="205" height="25" fill="url(#plankGrad3)" />
          <rect x="0" y="754" width="205" height="25" fill="url(#woodGrain)" />
          <rect x="207" y="754" width="185" height="25" fill="url(#plankGrad1)" />
          <rect x="207" y="754" width="185" height="25" fill="url(#woodGrain)" />
          <rect x="394" y="754" width="220" height="25" fill="url(#plankGrad2)" />
          <rect x="394" y="754" width="220" height="25" fill="url(#woodGrain)" />
          <rect x="616" y="754" width="192" height="25" fill="url(#plankGrad3)" />
          <rect x="616" y="754" width="192" height="25" fill="url(#woodGrain)" />
          <rect x="810" y="754" width="218" height="25" fill="url(#plankGrad1)" />
          <rect x="810" y="754" width="218" height="25" fill="url(#woodGrain)" />
          <rect x="1030" y="754" width="195" height="25" fill="url(#plankGrad2)" />
          <rect x="1030" y="754" width="195" height="25" fill="url(#woodGrain)" />
          <rect x="1227" y="754" width="213" height="25" fill="url(#plankGrad3)" />
          <rect x="1227" y="754" width="213" height="25" fill="url(#woodGrain)" />

          {/* Row 4 - bottom */}
          <rect x="-40" y="781" width="195" height="25" fill="url(#plankGrad1)" />
          <rect x="-40" y="781" width="195" height="25" fill="url(#woodGrain)" />
          <rect x="157" y="781" width="208" height="25" fill="url(#plankGrad2)" />
          <rect x="157" y="781" width="208" height="25" fill="url(#woodGrain)" />
          <rect x="367" y="781" width="188" height="25" fill="url(#plankGrad3)" />
          <rect x="367" y="781" width="188" height="25" fill="url(#woodGrain)" />
          <rect x="557" y="781" width="215" height="25" fill="url(#plankGrad1)" />
          <rect x="557" y="781" width="215" height="25" fill="url(#woodGrain)" />
          <rect x="774" y="781" width="198" height="25" fill="url(#plankGrad2)" />
          <rect x="774" y="781" width="198" height="25" fill="url(#woodGrain)" />
          <rect x="974" y="781" width="222" height="25" fill="url(#plankGrad3)" />
          <rect x="974" y="781" width="222" height="25" fill="url(#woodGrain)" />
          <rect x="1198" y="781" width="190" height="25" fill="url(#plankGrad1)" />
          <rect x="1198" y="781" width="190" height="25" fill="url(#woodGrain)" />
          <rect x="1390" y="781" width="200" height="25" fill="url(#plankGrad2)" />
          <rect x="1390" y="781" width="200" height="25" fill="url(#woodGrain)" />

          {/* Plank gap shadows */}
          <line x1="180" y1="700" x2="180" y2="725" stroke="#0a0604" strokeWidth="2" />
          <line x1="402" y1="700" x2="402" y2="725" stroke="#0a0604" strokeWidth="2" />
          <line x1="594" y1="700" x2="594" y2="725" stroke="#0a0604" strokeWidth="2" />
          <line x1="806" y1="700" x2="806" y2="725" stroke="#0a0604" strokeWidth="2" />
          <line x1="993" y1="700" x2="993" y2="725" stroke="#0a0604" strokeWidth="2" />
          <line x1="1220" y1="700" x2="1220" y2="725" stroke="#0a0604" strokeWidth="2" />
        </g>

        {/* Cobwebs in corners */}
        <path
          className="cobweb cobweb-1"
          d="M0,0 Q60,20 30,80 M0,0 Q40,40 20,100 M0,0 Q20,60 10,120"
          fill="none"
          stroke="rgba(150,150,150,0.2)"
          strokeWidth="1"
        />
        <path
          className="cobweb cobweb-2"
          d="M1440,0 Q1380,20 1410,80 M1440,0 Q1400,40 1420,100 M1440,0 Q1420,60 1430,120"
          fill="none"
          stroke="rgba(150,150,150,0.2)"
          strokeWidth="1"
        />
      </svg>

      {/* Flickering candlelight glow */}
      <Box
        className="candle-glow"
        position="absolute"
        bottom="25%"
        left="50%"
        transform="translateX(-50%)"
        width="400px"
        height="300px"
        borderRadius="50%"
        background="radial-gradient(ellipse, rgba(255,150,50,0.08) 0%, rgba(255,100,30,0.04) 40%, transparent 70%)"
      />

      {/* Dust particles */}
      <Box className="dust-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(12)].map((_, i) => (
          <Box
            key={i}
            className={`dust dust-${i + 1}`}
            position="absolute"
            width={2 + (i % 2) + "px"}
            height={2 + (i % 2) + "px"}
            borderRadius="50%"
            backgroundColor="rgba(200,200,200,0.3)"
            opacity="0"
          />
        ))}
      </Box>

      {/* Shadows creeping from edges */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        background="radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,0.4) 100%)"
        pointerEvents="none"
      />

      {/* Occasional lightning flash overlay */}
      <Box
        className="lightning-flash"
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        backgroundColor="rgba(200,200,255,0.1)"
        opacity="0"
        pointerEvents="none"
      />
    </Box>
  );
};

export default HauntedHouseBackground;
